(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6800],{

/***/ 76800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ productsModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/dist/reach-dialog.mjs + 49 modules
var reach_dialog = __webpack_require__(42128);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/productsModal/ProductsModal.module.scss
var ProductsModal_module = __webpack_require__(11922);
var ProductsModal_module_default = /*#__PURE__*/__webpack_require__.n(ProductsModal_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/productsModal/Product.js








var ProductConfig = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3082).then(__webpack_require__.bind(__webpack_require__, 33082));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(33082)];
    }
  }
});

var Product = function Product(_ref) {
  var _media$;

  var product = _ref.product,
      index = _ref.index,
      removeProduct = _ref.removeProduct,
      length = _ref.length,
      updatedCurrentSlugs = _ref.updatedCurrentSlugs,
      sizeChoosenModalState = _ref.sizeChoosenModalState,
      setSizeLookItem = _ref.setSizeLookItem,
      key = _ref.key;
  var brand = product.brand,
      name = product.name,
      old_price = product.old_price,
      price = product.price,
      _product$attributes = product.attributes,
      attributes = _product$attributes === void 0 ? [] : _product$attributes,
      model = product.model,
      _product$media = product.media,
      media = _product$media === void 0 ? [] : _product$media,
      price_diff_percent = product.price_diff_percent;

  var _useState = (0,react.useState)(null),
      currentSlug = _useState[0],
      setCurrentSlug = _useState[1];

  var switchAttributes = (0,react.useMemo)(function () {
    return attributes.filter(function (attr) {
      return attr.type === 'switch';
    }) || [];
  }, [attributes]);

  var _useState2 = (0,react.useState)(price),
      actualPrice = _useState2[0],
      setActualPrice = _useState2[1];

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'product',
    value: model.slug
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      href = _getLinkProps2[0],
      as = _getLinkProps2[1];

  (0,react.useEffect)(function () {
    setActualPrice(price);
  }, [price]);
  var handleSetCurrentSlug = (0,react.useCallback)(function (newSlug) {
    updatedCurrentSlugs(newSlug, index);
    setCurrentSlug(newSlug);
  }, [updatedCurrentSlugs, index]);
  var handleSetActualPrice = (0,react.useCallback)(function (newPrice) {
    setActualPrice(newPrice !== null && newPrice !== void 0 ? newPrice : price);
  }, [price]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ProductsModal_module_default()).main,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      href: as,
      target: "_blank",
      className: (ProductsModal_module_default()).leftSection,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (ProductsModal_module_default()).image,
        src: (_media$ = media[0]) === null || _media$ === void 0 ? void 0 : _media$.x2,
        alt: name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductsModal_module_default()).description,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductsModal_module_default()).brand,
          children: brand
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductsModal_module_default()).name,
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductsModal_module_default()).priceBlock,
          children: [Number(old_price) > Number(actualPrice) && !!price_diff_percent && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductsModal_module_default()).discountPercent,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductFeature */["if"], {
              title: "".concat(price_diff_percent, "%"),
              styledType: "sale"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductsModal_module_default()).price,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Price */.tA, {
              price: actualPrice,
              oldPrice: old_price,
              mod: "face-item",
              isLookProduct: true
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductsModal_module_default()).rightSection,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductConfig, {
        switchAttributes: switchAttributes,
        currentSlug: currentSlug,
        slug: model.slug,
        actualPrice: price,
        setActualPrice: handleSetActualPrice,
        setCurrentSlug: handleSetCurrentSlug,
        setSizeLookItem: setSizeLookItem,
        sizeChoosenModalState: sizeChoosenModalState,
        data: product,
        isModal: true,
        isLook: true,
        noBucketButton: true,
        index: index,
        productInfo: {
          pageName: 'Идеи для образа',
          indexCard: index
        }
      })
    }), length > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      onClick: function onClick() {
        return removeProduct(index);
      },
      className: (ProductsModal_module_default()).removeProduct,
      src: "/images/svg/close.svg",
      alt: "remove"
    })]
  }, key);
};

/* harmony default export */ var productsModal_Product = (Product);
;// CONCATENATED MODULE: ./components/productsModal/ProductsModal.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var orderAllLook = 'Заказать весь образ';
var orderAllGoods = 'Заказать все товары';

var ProductsModal = function ProductsModal(_ref) {
  var showDialog = _ref.showDialog,
      onDismiss = _ref.onDismiss,
      goods = _ref.products,
      loading = _ref.loading,
      _ref$isLook = _ref.isLook,
      isLook = _ref$isLook === void 0 ? false : _ref$isLook;
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  var cartLoading = (0,es/* useSelector */.v9)(cartSlice/* getCartDataLoading */.hY);

  var _useSelector = (0,es/* useSelector */.v9)(store/* cartInfoSelector */.wg),
      ids = _useSelector.ids,
      count = _useSelector.count;

  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);

  var _useState = (0,react.useState)([]),
      products = _useState[0],
      setProducts = _useState[1];

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState2 = (0,react.useState)(false),
      isConfirmOrder = _useState2[0],
      setIsConfirmOrder = _useState2[1];

  var _useState3 = (0,react.useState)({
    selectedSlugs: [],
    validated: false
  }),
      sizeChoosenModalState = _useState3[0],
      setSizeChosenModalState = _useState3[1];

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'cart'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      cartHref = _getLinkProps2[0],
      cartAs = _getLinkProps2[1];

  var currentSlugs = (0,react.useMemo)(function () {
    return products.map(function (_ref2) {
      var slug = _ref2.slug;
      return slug;
    });
  }, [products]);

  var getInitialSizeChosenModalState = function getInitialSizeChosenModalState(productItems) {
    return productItems.map(function (item) {
      if (item.attributes.some(function (attr) {
        return attr.name === 'Размер производителя';
      })) {
        return null;
      }

      return item.model.slug;
    });
  };

  (0,react.useEffect)(function () {
    if (products.length) {
      setSizeChosenModalState(function (prev) {
        var newSelectedSlugs = (0,toConsumableArray/* default */.Z)(getInitialSizeChosenModalState(products));

        for (var i = 0; i < newSelectedSlugs.length; i++) {
          if (prev.selectedSlugs[i]) {
            newSelectedSlugs[i] = prev.selectedSlugs[i];
          }
        }

        return _objectSpread(_objectSpread({}, prev), {}, {
          selectedSlugs: newSelectedSlugs,
          validated: newSelectedSlugs.every(function (value) {
            return value;
          })
        });
      });
    }
  }, [products]);

  var setSizeLookModal = function setSizeLookModal(index, sizeState) {
    return function (slug) {
      setSizeChosenModalState(function (prev) {
        var newState = (0,toConsumableArray/* default */.Z)(prev.selectedSlugs);

        newState[index] = slug;
        var validated = newState.every(function (value) {
          return value;
        });
        return {
          selectedSlugs: newState,
          validated: validated
        };
      });
    };
  };

  var updatedCurrentSlugs = (0,react.useCallback)(function (slug, index) {
    currentSlugs.splice(index, 1, slug);
  }, [currentSlugs]);
  var removeProduct = (0,react.useCallback)(function (index) {
    setProducts(function (prev) {
      return prev.filter(function (_, i) {
        return i !== index;
      });
    });
    currentSlugs.splice(index, 1);

    var newSizeModalState = (0,toConsumableArray/* default */.Z)(sizeChoosenModalState.selectedSlugs);

    newSizeModalState.splice(index, 1);
    setSizeChosenModalState(_objectSpread(_objectSpread({}, sizeChoosenModalState), {}, {
      selectedSlugs: newSizeModalState,
      validated: newSizeModalState.every(function (state) {
        return state;
      })
    }));
  }, [currentSlugs, sizeChoosenModalState]);
  (0,react.useEffect)(function () {
    if (goods.length) {
      setProducts(goods);
    }
  }, [goods]);
  var onConfirmOrder = (0,react.useCallback)(function () {
    setIsConfirmOrder(true);
    var dataArray = sizeChoosenModalState.selectedSlugs.filter(function (product) {
      return !ids.includes(product);
    });
    var mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');
    dispatch((0,cartSlice/* createLookInCart */.C2)({
      products: dataArray.map(function (product) {
        return {
          id: product,
          quantity: 1
        };
      }),
      meta: {
        pageName: isLook ? orderAllLook : orderAllGoods
      },
      mindboxDeviceUUID: mindboxDeviceUUID || '',
      onSuccess: function onSuccess(props) {
        onDismiss();
        dispatch((0,cartSlice/* updateCartIds */.U9)({
          ids: [].concat((0,toConsumableArray/* default */.Z)(ids), (0,toConsumableArray/* default */.Z)(dataArray))
        }));
        dispatch((0,cartSlice/* updateCartCount */.N1)({
          count: count + dataArray.length
        }));
      }
    }));

    var changeProductDataSize = function changeProductDataSize(data) {
      try {
        var attributes = [];

        for (var i = 0; i < data.attributes.length; i++) {
          var attribute = data.attributes[i];

          if (attribute.name === 'Основной цвет' || attribute.name === 'Размер производителя') {
            var value = attribute.options[0].name;
            attributes.push({
              value: value
            });
          }
        }

        return _objectSpread(_objectSpread({}, data), {}, {
          quantity: 1,
          switchable_attributes: attributes
        });
      } catch (error) {
        console.warn('size value was not sent correctly');
        console.warn(error);
        return data;
      }
    };

    var newProducts = products.map(function (item) {
      var newData = changeProductDataSize(item);
      return _objectSpread({}, newData);
    });
    Ecommerce/* default.viewItemList */.ZP.viewItemList(newProducts, currency, isLook ? orderAllLook : orderAllGoods, 'add_to_cart');
  }, [sizeChoosenModalState, products, dispatch, currency, count, ids, isLook]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(reach_dialog/* DialogOverlay */.t9, {
    isOpen: showDialog,
    "aria-label": undefined,
    className: (0,clsx_m/* default */.Z)((ProductsModal_module_default()).root, hasSmartBanner && (ProductsModal_module_default()).rootBanner),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(reach_dialog/* DialogContent */.cZ, {
      className: (0,clsx_m/* default */.Z)((ProductsModal_module_default()).dialog),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductsModal_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ProductsModal_module_default()).title,
          children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0448\u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B"
        }), isConfirmOrder ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: cartHref,
          as: cartAs,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
            classNames: {
              general: (ProductsModal_module_default()).button
            },
            type: "primary",
            loading: cartLoading,
            children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443"
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          type: "primary",
          onClick: onConfirmOrder,
          classNames: {
            general: (ProductsModal_module_default()).button
          },
          disabled: !sizeChoosenModalState.validated,
          children: isLook ? orderAllLook : orderAllGoods
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          onClick: onDismiss,
          className: (ProductsModal_module_default()).close,
          src: "/images/svg/close.svg",
          alt: "close"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductsModal_module_default()).products,
        children: products.length ? products.map(function (product, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(productsModal_Product, {
            product: product,
            index: index,
            removeProduct: removeProduct,
            loading: loading,
            length: products.length,
            sizeChoosenModalState: sizeChoosenModalState.selectedSlugs,
            updatedCurrentSlugs: updatedCurrentSlugs,
            setSizeLookItem: setSizeLookModal(index, sizeChoosenModalState),
            isLooks: true
          }, product.slug);
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductsModal_module_default()).skeleton,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ProductsModal_module_default()).skeletonBlock,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ProductsModal_module_default()).skeletonImage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "100%",
                width: "100%",
                style: {
                  marginBottom: '24px'
                }
              }, 'skeleton-shop1')
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ProductsModal_module_default()).skeletonDescription,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "24px",
                width: "60px",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop2'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "48px",
                width: "100%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop3'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "24px",
                width: "80px",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop3')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((ProductsModal_module_default()).skeletonDescription, (ProductsModal_module_default()).skeletonSize),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "32px",
                width: "90%",
                style: {
                  marginBottom: '16px'
                }
              }, 'skeleton-shop2'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "24px",
                width: "25%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop3')]
            })]
          }, 'look-skeleton-1'), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ProductsModal_module_default()).skeletonBlock,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ProductsModal_module_default()).skeletonImage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "100%",
                width: "100%",
                style: {
                  marginBottom: '24px'
                }
              }, 'skeleton-shop1')
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ProductsModal_module_default()).skeletonDescription,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "24px",
                width: "60px",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop2'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "48px",
                width: "100%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop3'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "24px",
                width: "80px",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop3')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((ProductsModal_module_default()).skeletonDescription, (ProductsModal_module_default()).skeletonSize),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "32px",
                width: "90%",
                style: {
                  marginBottom: '16px'
                }
              }, 'skeleton-shop2'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: "24px",
                width: "25%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton-shop3')]
            })]
          }, 'look-skeleton-2')]
        })
      })]
    })
  });
};

/* harmony default export */ var productsModal_ProductsModal = (ProductsModal);
;// CONCATENATED MODULE: ./components/productsModal/index.js

/* harmony default export */ var productsModal = (productsModal_ProductsModal);

/***/ }),

/***/ 11922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductsModal_root__kmMII","rootBanner":"ProductsModal_rootBanner__X7aAx","dialog":"ProductsModal_dialog__umOV0","close":"ProductsModal_close__u6Kw4","header":"ProductsModal_header__n_nan","title":"ProductsModal_title__aSF4y","main":"ProductsModal_main__PuV38","removeProduct":"ProductsModal_removeProduct__vpSDM","button":"ProductsModal_button__I0pgN","leftSection":"ProductsModal_leftSection__D2p7j","image":"ProductsModal_image__iREGa","brand":"ProductsModal_brand__VnXZp","name":"ProductsModal_name__8MVft","priceBlock":"ProductsModal_priceBlock__ljUbl","price":"ProductsModal_price__WqQYL","discountPercent":"ProductsModal_discountPercent__q3yq7","oldPrice":"ProductsModal_oldPrice__GPMN0","newPrice":"ProductsModal_newPrice__nlNdH","sale":"ProductsModal_sale__zPnQu","rightSection":"ProductsModal_rightSection__qacPH","color":"ProductsModal_color__5m81_","sizeBlock":"ProductsModal_sizeBlock__vwfhf","size":"ProductsModal_size__0yCiR","sizeText":"ProductsModal_sizeText__pNckc","addToCart":"ProductsModal_addToCart__AjH9t","description":"ProductsModal_description__hUU14","products":"ProductsModal_products__n_QSy","skeleton":"ProductsModal_skeleton__JCYC4","skeletonBlock":"ProductsModal_skeletonBlock__ovJfN","skeletonImage":"ProductsModal_skeletonImage__PdhhB","skeletonDescription":"ProductsModal_skeletonDescription__h6Lto","skeletonSize":"ProductsModal_skeletonSize__ChU5u","load":"ProductsModal_load__w6DSG"};

/***/ })

}]);